<ul>
	<li #SidebarlistElement class="mb-1">
		<a [ngClass]="{'active': isActive}" class="font-sidebar-items" (click)="navigateTo()" (mouseover)="hover=true" (mouseleave)="hover=false" [ngStyle]="hover ? colorTextHeader : null">
			<span class="viz-font-sidebar-items me-1" [ngStyle]="hover ? colorTextHeader : null">{{ 'VIZ.VIZ' | translate}}</span>{{ activity.label | translate }}
		</a>
	</li>
</ul>